module.exports = __webpack_public_path__ + "static/img/beautiful_horn.b27f064.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/beautiful_horn.png
// module id = j9yI
// module chunks = 1